module.exports = __webpack_public_path__ + "static/media/Teen_HoPro-dt-en.0b04d009.jpg";